import DownloadIcon from 'components/Icons/DownloadIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import HrefDownload from '../../download/Arquivo_Guia_Importacao_Beneficiarios.txt';

interface Props {
  handleShowInstructions: () => void;
}

const IncludeModalButtons: React.FC<Props> = ({ handleShowInstructions }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <>
      <span className="text">{t('includeTeam:need_help')}</span>
      <div className="button-wrapper">
        <a
          href={HrefDownload}
          download="Arquivo_Guia_Importacao_Beneficiarios"
          target="_blank"
          rel="noreferrer"
          className="download-anchor"
        >
          <button type="button" className="download-button">
            {t('includeTeam:download_model')}
            <DownloadIcon />
          </button>
        </a>
        <button
          type="button"
          className="instructions-button"
          onClick={handleShowInstructions}
          data-testid="test-show-instructions"
        >
          {t('includeTeam:access_instructions')}
        </button>
      </div>
    </>
  );
};

export default IncludeModalButtons;
